<template>
  <div>
    <div id='content' style="position: relative;">
      <!-- 飘花 -->
      <div id="snowflake"></div>   
      <img src="static/img/act/4/bg.jpg" class="bg" />
      <router-link :to="{ path: '/act4/main/newslist', query: { type: 1 , cid: 200, idArray: '65171,65166,65294'}}">
        <div class="btn btn-rs" ></div> 
      </router-link> 
      <router-link :to="{ path: '/act4/main/newslist', query: { type: 2 , cid: 200, idArray: '65170,65058'}}">
        <div class="btn btn-sj" ></div>  
      </router-link> 
      <router-link :to="{ path: '/act4/main/newslist', query: { type: 3 , cid: 200, idArray: '65205,65292'}}">
        <div class="btn btn-ra" ></div>     
      </router-link> 
      <router-link :to="{ path: '/act4/main/news', query: { id: 65203}}">
        <div class="btn btn-lc"></div>
      </router-link>
      <router-link :to="{ path: '/act4/main/newslist', query: { type: 4 , cid: 200, idArray: '65172,65063,65287,65164,65163,65162,65148,65289,65053'}}">
        <div class="btn btn-lz" ></div>
      </router-link>
      <router-link :to="{ path: '/act4/main/news', query: { id: 65196}}">
        <div class="btn btn-lj" ></div>
      </router-link>
      <router-link :to="{ path: '/act4/main/newslist', query: { type: 5 , cid: 200, idArray: '65298,65299,65062,65300'}}">
        <div class="btn btn-luzhai"></div>
      </router-link>
    </div> 

    <!-- 文章列表 -->
    <div v-if="true" class="comment-components" style="overflow-y: scroll;" v-bind:style="{ transform:DialogList.NewsListDialog.y,opacity:DialogList.NewsListDialog.opacity,zIndex:DialogList.NewsListDialog.level + 4 }"> 
      <list-style-1 ref="refNewsList"></list-style-1>      
    </div>           
    <!-- 文章列表 end -->     
    
    <!-- 遮罩层 -->   
      <div v-show="ModalMaskVisible" class="modal-mask" style="z-index: 4; " v-bind:style="{ opacity:1}" @click="closeOneLevelModalMask" ></div>
    <!-- 遮罩层 end --> 

  </div>
</template>

<script>
  import { Tabbar, TabbarItem  } from 'vant';
  //动画
  import Velocity from 'velocity-animate'
  //窗口
  import {Act1NewsListDialog} from '@/api/MenuDialog' 

  export default {
    name: 'Act4Main',
    components: {
      'van-tabbar':Tabbar,
      'van-tabbar-item':TabbarItem, 
      'list-style-1':()=>{
	    return import('@/components/list/ListStyle1.vue')
	    },
    },
    data() {
      return { 
        snowflakeURl: [
          'static/img/act/4/flower/images/icon_petal_1.png',
          'static/img/act/4/flower/images/icon_petal_2.png',
          'static/img/act/4/flower/images/icon_petal_3.png',
          'static/img/act/4/flower/images/icon_petal_4.png',
          'static/img/act/4/flower/images/icon_petal_5.png'
        ],
        timer: '',　
        //=-窗口操作
        ModalMaskVisible:false,
        ModalMaskOpacity:0,
        DialogList:{
          NewsListDialog:Act1NewsListDialog,
        },
        //=-窗口操作 end
      }
    }, 
    destroyed(){
      this.c("销毁-act-4", '!!!!!!!!!!')
      clearInterval(this.timer)
    },
    mounted() {
      this.c("搞-act-4", '!!!!!!!!!!')
      this.existsHistory("?acb")
    },
    created() {
      //页面设置
      this.setDocumentV2(
        "三月三，去撒欢", 
        "",
        "https://z.lzgd.com.cn/inliuzhou/2018/LiuzhouTourism/static/img/act/4/share.jpg?v=2"
      );
      _czc.push(['_trackEvent', '三月三，去撒欢', '点击', '活动主页面','0','4']);
      //飘花动画
      this.snowflake()
    },
    methods: {
      //随机六张图
      getImagesName(){
        return this.snowflakeURl[[Math.floor(Math.random() * 5)]];
      },
      // 创建一个雪花元素
      createSnowBox(){
        var url = this.getImagesName();
        var flowerDiv = document.createElement("img");
        flowerDiv.class = "snowbox";
        flowerDiv.src = url;
        flowerDiv.style.cssText = "position:absolute;width:auto;max-width:100%;height:auto;top:-41px;background-repeat:no-repeat;zIndex:100000;";
        return flowerDiv;
      },
      snowflake() {
        let vm = this
        // 雪花容器
        var $flakeContainer = document.getElementById("snowflake")　　　　　　
        // 开始飘花
        vm.timer = setInterval(function() {
          var parent = document.getElementById("content");
          var parentHeight = parent.innerHeight || parent.clientHeight;

          if(!parentHeight || parentHeight == 0 || parentHeight == '0px') {
            //console.log("parentHeight:",parentHeight)
            return
          }

          var container = document.getElementById("content");
          var visualWidth = container.innerWidth || container.clientHeight || container.clientHeight;
          var visualHeight = container.innerHeight || container.clientHeight || container.clientHeight;

          // 运动的轨迹
          var startPositionLeft = Math.random() * visualWidth - 100,
            startOpacity = 1,
            endPositionTop = visualHeight - 40,
            endPositionLeft = startPositionLeft - 100 + Math.random() * 500,
            duration = visualHeight * 10 + Math.random() * 5000;
          // 随机透明度，不小于0.5
          var randomStart = Math.random();
          randomStart = randomStart < 0.5 ? startOpacity : randomStart;
          // 创建一个雪花
          var $flake = vm.createSnowBox();
          //添加旋转
          $flake.classList.add("snowRoll");
          // 设计起点位置
          $flake.style["left"] = startPositionLeft + 'px';
          $flake.style["opacity"] = 1 //randomStart;
          // 加入到容器
          document.getElementById("snowflake").append($flake);
          endPositionTop = endPositionTop + 80
          // 开始执行动画
          Velocity($flake, {
            top: endPositionTop,
            left: endPositionLeft,
            opacity: 1
          }, {
            easing: "easeOut",
            duration: duration,
            complete: function() {
              $flake.remove() //结束后删除
            }
          });
        }, 700);
      },
      displayActList(type) {
        return;
        //显示窗口
        this.DialogList.NewsListDialog.show();
        this.DialogList.NewsListDialog.level =  ( this.getDialogTopLevel() + 1 )        
        //打开遮罩
        this.openModalMask()

        let shareimgA  = 'https://z.lzgd.com.cn/inliuzhou/2018/LiuzhouTourism/static/img/act/4/share.jpg?v=2'
        let actId = 4;
        let id = type;
        let cid = 200
        let idArray = ''
        let title = ''    
          if( type == 1 ){
            cid = 200  
            title = '融水宝典'
            idArray = '65171,65166,65294'
            _czc.push(['_trackEvent', '三月三，去撒欢', '点击', '“融水宝典”页面',id,actId]);
          } else if( type == 2 ){
            cid = 200  
            title = '三江宝典'
            idArray = '65170,65058'
            _czc.push(['_trackEvent', '三月三，去撒欢', '点击', '“三江宝典”页面',id,actId]);
          }  else if( type == 3 ){
            cid = 200  
            title = '融安宝典'
            idArray = '65205,65292'
            _czc.push(['_trackEvent', '三月三，去撒欢', '点击', '“融安宝典”页面',id,actId]);
          } else if( type == 5 ){
            cid = 200  
            title = '柳州市区'
            idArray = '65172,65063,65287,65164,65163,65162,65148,65289,65053'
            _czc.push(['_trackEvent', '三月三，去撒欢', '点击', '“柳州市区”页面',id,actId]);
          } else if( type == 7 ){ 
           // idArray = '65298,65299,65062,65300' 
            cid = 200  
            title = '鹿寨宝典'
            idArray = '65298,65299,65062,65300'
            _czc.push(['_trackEvent', '三月三，去撒欢', '点击', '“鹿寨宝典”页面',id,actId]);
          }

        let vm = this
        setTimeout(function(){
          vm.$refs.refNewsList.getInid(cid,8,idArray)    
        },400)
        
      },
      //=-窗口操作
      
       //目前窗口最高
      getDialogTopLevel(){
        this.c("getDialogTopLevel","begin")
        let topLive = 0
        for(let key in this.DialogList){          
          if( this.DialogList[key].level > topLive && !this.DialogList[key].isHide()){           
            topLive = this.DialogList[key].level
          }
        }
        this.c("目前窗口最高",topLive)
        return topLive
      },      
      //打开遮罩
      openModalMask(){               
        let vm = this        
        //if( this.getDialogTopLevel() > 0){
          this.c("openModalMask","打开遮罩")
          this.ModalMaskVisible = true
        //}
      },      
      //关闭遮罩层
      closeOneLevelModalMask(){
        
        this.c("closeOneLevelModalMask","关闭一级遮罩层")
         let vm = this
         
        //关闭最高层
        let topLive = this.getDialogTopLevel()
        let closedSetDocument = false
        for(let key in this.DialogList){
          if( this.DialogList[key].level == topLive){
            this.DialogList[key].hide()
            closedSetDocument = this.DialogList[key].closedSetDocument
          }
        }
        topLive = this.getDialogTopLevel()
        this.c("closeOneLevelModalMask->topLive",topLive)
        if(topLive <= 1){
          this.ModalMaskVisible = false
        }
        this.c("closeOneLevelModalMask->closedSetDocument",closedSetDocument)
        //设置标题
        if(closedSetDocument){
          let title = ''      
          topLive = 0
          let path = ''
          for(let key in this.DialogList){
            if( this.DialogList[key].level > topLive && !this.DialogList[key].isHide() && this.DialogList[key].closedSetDocument){           
              title = this.DialogList[key].name
              path = this.DialogList[key].path
              topLive = topLive
              this.c("title",title)
            }
          }
          if(title!= ''){
            this.setDocument(title,path,'','')
          }
        }
      
      }
      //=-窗口操作 end
    }
  }
</script>

<style scoped>
  .bg {
    width: 100%;
  }
  
  .btn {
    position: absolute;
    width: 25%;
    height: 8%;
  }
  
  .btn-rs {
    top: 13.5%;
    left: 2%;
  }
  
  .btn-sj {
    top: 11.5%;
    left: 73%;
  }
  
  .btn-ra {
    top: 28.5%;
    left: 73%;
  }
  
  .btn-lz {
    top: 44.2%;
    left: 75%;
  }
  
  .btn-lj {
    top: 78.2%;
    left: 2%;
  }
  
  .btn-lc {
    top: 47.5%;
    left: 2%;
  }
  
  .btn-luzhai {
    top: 79.3%;
    left: 73%;
  }
  
  img {
    border: 0;
    vertical-align: middle
  }
  
  #content {
   /* position: absolute;
    width: 100%;
    height: 100%;
    top: 0px;
    overflow: hidden;*/
  }
  
  #snowflake {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    overflow: hidden;
  }
</style>

<style>
  @keyframes mysnow {
    0% {
      bottom: 100%;
    }
    50% {
      transform: rotate(1080deg);
    }
    100% {
      transform: rotate(0deg) translate3d(50px, 50px, 50px);
    }
  }
  @-webkit-keyframes mysnow {
    0% {
      bottom: 100%;
    }
    50% {
      -webkit-transform: rotate(1080deg);
    }
    100% {
      -webkit-transform: rotate(0deg) translate3d(50px, 50px, 50px);
    }
  }
  
  @-moz-keyframes mysnow {
    0% {
      bottom: 100%;
    }
    50% {
      -moz-transform: rotate(1080deg);
    }
    100% {
      -moz-transform: rotate(0deg) translate3d(50px, 50px, 50px);
    }
  }
  
  .snowRoll {
    position: absolute;
    opacity: 0;
    animation-name: mysnow;
    animation-duration: 20s;
    -webkit-animation-name: mysnow;
    -webkit-animation-duration: 20s;
    -moz-animation-name: mysnow;
    -moz-animation-duration: 20s;
    height: 80px;
  }


/* 窗口 */

 .comment-components{
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    z-index: 6;
    height: calc(100% - 1.37rem);
    background-color: #FFFFFF;
    overflow: hidden;
    -webkit-overflow-scrolling:touch;
    -webkit-transition: opacity 500ms ease,transform 400ms ease;
    transition: opacity 500ms ease,transform 400ms ease;
    -webkit-transform: translateZ(0);
    -moz-transform: translateZ(0);
    -ms-transform: translateZ(0);
    -o-transform: translateZ(0);
    transform: translateZ(0);
 } 
.modal-mask{
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  width: 100%;
  height: 100%;
  z-index: 5;
  background-color: rgba(0,0,0,0);
  -webkit-transition: opacity 300ms ease;
  transition: opacity 300ms ease;
}
  
</style>


// WEBPACK FOOTER //
// src/components/act/4/main.vue